var Block = Chaplin.Model.extend({

});

module.exports = Block;